module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sales/interests/interests.component.css
// module id = ./src/app/components/sales/interests/interests.component.css
// module chunks = main